export const isUserAuthenticated = () => {
  const isAuthenticated = localStorage.getItem('isLogin') === 'true';
  return isAuthenticated;
};
export const isTokenAuthenticated = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return false;
  }

  try {
    // Parse the token to get the expiration time
    const { exp } = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return exp > currentTime; // Check if token is still valid
  } catch (error) {
    return false; // Invalid token format
  }
};
const daya = isTokenAuthenticated();
